export const listBasicPeople = /* GraphQL */ `
  query ListPeople(
    $id: ID
    $filter: ModelPersonFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listPeople(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        email
        firstName
        lastName
        isVerified
        roles
        personalInformationId
        pictureURL
        disciplines
        stripeId
        createdBy
        createdOn
        updatedOn
      }
      nextToken
    }
  }
`;